
import {
  computed, defineComponent, PropType, Ref, toRefs,
} from 'vue';
import { format as formatCurrency } from '@/lib/currency';
import { getPayoutClass, getPayoutLabel, PayoutCategory } from '@/lib/payout';

export interface GraphSegment {
  value: Ref<number>;
  category: PayoutCategory;
}

export default defineComponent({
  name: 'GraphBar',
  components: {},
  props: {
    globalMax: {
      type: Number,
      required: true,
    },
    segments: {
      type: Array as PropType<Array<GraphSegment>>,
      required: true,
    },
    description: null,
  },
  setup(props) {
    const { segments, globalMax } = toRefs(props);

    const toRenderSegment = (segment: GraphSegment) => {
      const value = Math.round(segment.value.value);
      const formattedValue = computed(() => formatCurrency(value));
      const height = Math.round((value / globalMax.value) * 100);
      const heightPercent = `${height}%`;
      const resultClass = getPayoutClass(segment.category);
      const label = `${getPayoutLabel(segment.category)}: ${formattedValue.value}`;

      return {
        value,
        formattedValue,
        height,
        heightPercent,
        resultClass,
        type: segment.category,
        label,
      };
    };

    const renderSegments = computed(() => segments.value.map(toRenderSegment));
    const visibleRenderSegments = computed(() => renderSegments.value.filter((segment) => segment.height > 0));
    const totalValue = computed(() => Math.round(renderSegments.value.reduce((acc, val) => acc + val.value, 0)));
    const formattedTotalValue = computed(() => formatCurrency(totalValue.value));
    const totalOfMaxPercent = computed(() => Math.round((totalValue.value / globalMax.value) * 100));

    return {
      totalValue,
      formattedTotalValue,
      totalOfMaxPercent,
      renderSegments,
      visibleRenderSegments,
    };
  },
});
